import {useDictionary} from '@adamlip/okeoke.client';
import FormattedNumber from 'components/FormattedNumber';
import useBasket from 'hooks/useBasket';

export default function ServiceFee() {
	const {getValue} = useDictionary();
	const {sumDiscountServiceFee, serviceFee} = useBasket();

	if (sumDiscountServiceFee == null || sumDiscountServiceFee === 0) return null;

	return (
		<div className='w-full flex flex-row justify-between items-center'>
			<div className='text-sm opacity-70'>
				{serviceFee?.type === 1 && `${getValue('app_v2_serviceFee')} (${serviceFee?.percent}%)`}
				{serviceFee?.type === 2 && getValue('app_v2_reverseServiceFee')}
			</div>
			<div className='text-sm opacity-70'>
				{serviceFee?.type === 1 && (
					<div className=''>
						<FormattedNumber value={sumDiscountServiceFee} />
					</div>
				)}
				{serviceFee?.type === 2 && <div className=''>{serviceFee?.percent} %</div>}
			</div>
		</div>
	);
}
